/*
  Chesapeake Hatchery: partner product date box (Nov 4, 2026).
  Same look as the Chesapeake chick hatch-date box (assets/ch-shop-date.css).
  Picking a ship week here selects the matching native Sex / Ship week variant,
  so Shopify stock, SKUs, weights, discounts and the daily supplier list keep working.
  Counts = each variant's Shopify inventory. No cart properties are added.
*/
(function () {
  'use strict';
  if (window.ChPartnerDate) return;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MI = {}; MONTHS.forEach(function (m, i) { MI[m] = i; });
  var SHARED_KEY = 'chShopHatchDate';
  var SHOW_ROWS = 6;

  function pad(n) { return String(n).padStart(2, '0'); }
  function weekIso(v) {
    var m = /([A-Z][a-z]{2})[a-z]*\.? (\d{1,2}), (\d{4})/.exec(v || '');
    if (!m || MI[m[1]] === undefined) return '';
    return m[3] + '-' + pad(MI[m[1]] + 1) + '-' + pad(Number(m[2]));
  }
  function addDays(iso, n) {
    var p = iso.split('-').map(Number), d = new Date(Date.UTC(p[0], p[1] - 1, p[2] + n));
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
  }
  function etToday() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var g = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; return ''; };
      return g('year') + '-' + g('month') + '-' + g('day');
    } catch (_) { var d = new Date(); return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  }
  function label(iso) { var p = iso.split('-').map(Number); return 'Week of ' + MONTHS[p[1] - 1] + ' ' + p[2]; }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function lc(s) { return String(s || '').toLowerCase(); }

  function mount(box) {
    var data;
    try { data = JSON.parse(box.querySelector('[data-ch-pd-data]').textContent); } catch (_) { return; }
    var variants = (data.variants || []).map(function (v) { v.iso = weekIso(v.week); return v; }).filter(function (v) { return v.iso; });
    var today = etToday();
    var lowStock = Number(box.dataset.lowStock) || 5;
    var noun = box.dataset.noun || 'birds';
    var form = (box.dataset.formId && document.getElementById(box.dataset.formId)) || document.querySelector('product-form form[action*="/cart/add"]');
    var msg = box.querySelector('[data-ch-sbd-msg]');
    var picker = box.querySelector('[data-ch-sbd-picker]');
    var select = picker.querySelector('select');
    var compare = box.querySelector('[data-ch-sbd-compare]');
    var table = box.querySelector('[data-ch-sbd-table]');
    var moreBtn = box.querySelector('[data-ch-sbd-more]');
    var showAll = false;

    var sexes = [], bySexWeek = {}, weeksSet = {};
    variants.forEach(function (v) {
      if (sexes.indexOf(v.sex) === -1) sexes.push(v.sex);
      bySexWeek[v.sex + '|' + v.iso] = v;
      if (v.iso >= today) weeksSet[v.iso] = true;
    });
    var allWeeks = Object.keys(weeksSet).sort();
    function left(sex, iso) { var v = bySexWeek[sex + '|' + iso]; return v ? Math.max(0, v.qty) : 0; }
    var open = allWeeks.filter(function (w) { return sexes.some(function (s) { return left(s, w) > 0; }); });

    function currentVariant() {
      var idInput = form && form.querySelector('[name="id"]');
      var id = idInput ? String(idInput.value) : '';
      return variants.find(function (v) { return String(v.id) === id; }) || null;
    }
    function currentSex() {
      var v = currentVariant();
      if (v) return v.sex;
      var s = document.querySelector('variant-selects select:not([data-ch-pd-skip])');
      return s ? s.value : sexes[0];
    }
    // The week the shopper chose. Starts empty unless the link carried a variant or a hatch date.
    var chosen = '';
    try {
      var url = new URL(location.href);
      if (url.searchParams.get('variant')) { var cv = currentVariant(); if (cv && cv.qty > 0) chosen = cv.iso; }
      if (!chosen) {
        var shared = url.searchParams.get('hatch') || localStorage.getItem(SHARED_KEY) || '';
        if (/^\d{4}-\d{2}-\d{2}$/.test(shared)) { var mon = addDays(shared, -1); if (open.indexOf(mon) !== -1) chosen = mon; }
      }
    } catch (_) {}

    function nativeWeekSelect() {
      var wrap = document.querySelector('[data-ch-pd-native-week]');
      return wrap ? wrap.querySelector('select') : null;
    }
    function syncNative() {
      if (!chosen) return;
      var s = nativeWeekSelect();
      var v = bySexWeek[currentSex() + '|' + chosen];
      if (!s || !v || s.value === v.week) return;
      var opt = Array.prototype.find.call(s.options, function (o) { return o.value === v.week; });
      if (!opt) return;
      s.value = v.week;
      s.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function fillSelect(sex) {
      select.replaceChildren(new Option('Choose a ship week', ''));
      open.forEach(function (w) {
        var n = left(sex, w);
        var o = new Option(label(w) + (n > 0 ? (n <= lowStock ? ' · Only ' + n + ' left' : ' · Available') : ' · Not this week'), w);
        o.disabled = n <= 0;
        select.add(o);
      });
      select.value = chosen && left(sex, chosen) > 0 ? chosen : '';
    }
    function renderTable(sex) {
      if (!open.length) { compare.hidden = true; return; }
      table.replaceChildren();
      var thead = el('thead'), hr = el('tr');
      var th0 = el('th', null, 'Ship week'); th0.scope = 'col'; hr.appendChild(th0);
      sexes.forEach(function (s) { var th = el('th', s === sex && sexes.length > 1 ? 'is-current' : null, sexes.length > 1 ? s : 'Available'); th.scope = 'col'; hr.appendChild(th); });
      thead.appendChild(hr); table.appendChild(thead);
      var tbody = el('tbody');
      var rows = showAll ? open : open.slice(0, SHOW_ROWS);
      if (!showAll && chosen && open.indexOf(chosen) >= SHOW_ROWS) rows = rows.concat([chosen]);
      rows.forEach(function (w) {
        var tr = el('tr', w === chosen ? 'is-selected' : null);
        var td0 = el('th'); td0.scope = 'row';
        var b = el('button', 'ch-sbd-product__pick', label(w));
        b.type = 'button';
        b.setAttribute('aria-pressed', w === chosen ? 'true' : 'false');
        b.addEventListener('click', function () { choose(w); });
        td0.appendChild(b); tr.appendChild(td0);
        sexes.forEach(function (s) {
          var n = left(s, w);
          var td = el('td', (s === sex && sexes.length > 1 ? 'is-current ' : '') + (n > 0 ? '' : 'is-out'), n > 0 ? String(n) : '—');
          if (n <= 0) td.setAttribute('aria-label', 'none left');
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      moreBtn.hidden = open.length <= SHOW_ROWS;
      moreBtn.textContent = showAll ? 'Show fewer weeks' : 'Show all ' + open.length + ' weeks';
      compare.hidden = false;
    }
    function render() {
      var sex = currentSex();
      if (!open.length) {
        box.dataset.state = 'soon';
        msg.textContent = '2027 ship weeks for this breed will be posted soon.';
        picker.hidden = true; compare.hidden = true;
        return;
      }
      picker.hidden = false;
      fillSelect(sex);
      var sexLabel = sexes.length > 1 ? lc(sex) + ' ' : '';
      if (chosen) {
        var n = left(sex, chosen);
        if (n > 0) {
          box.dataset.state = 'ok';
          msg.textContent = n <= lowStock ? label(chosen) + ': only ' + n + ' ' + sexLabel + noun + ' left. They\'ll go in your cart with this ship week.' : label(chosen) + ': ' + sexLabel + noun + ' available. They\'ll go in your cart with this ship week.';
        } else {
          var next = open.find(function (w) { return w > chosen && left(sex, w) > 0; }) || open.find(function (w) { return left(sex, w) > 0; });
          var others = sexes.filter(function (s) { return s !== sex && left(s, chosen) > 0; }).map(lc);
          box.dataset.state = 'warn';
          msg.textContent = sex + ' isn\'t available for the week of ' + label(chosen).replace('Week of ', '') + '.' +
            (others.length ? ' Available that week: ' + others.join(', ') + '.' : '') +
            (next ? ' Next ' + lc(sex) + ' ship week: ' + label(next) + '.' : '');
        }
      } else {
        var first = open.find(function (w) { return left(sex, w) > 0; });
        box.dataset.state = 'info';
        msg.textContent = first ? 'Next ship week for ' + sexLabel + noun + ': ' + label(first) + '. Pick a week to see what\'s available.' :
          (sexes.length > 1 ? sex + ' isn\'t open on any upcoming ship week yet.' : 'No ship weeks are open yet.');
      }
      renderTable(sex);
    }
    function choose(w) { chosen = w || ''; syncNative(); render(); }

    select.addEventListener('change', function () { choose(select.value); });
    moreBtn.addEventListener('click', function () { showAll = !showAll; render(); });
    // Sex changes re-render the native picker; keep the chosen week on the new sex.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects') && !e.target.closest('[data-ch-pd-native-week]')) setTimeout(function () { syncNative(); render(); }, 80); setTimeout(render, 900);
    });
    // PUB_SUB_EVENTS is a top-level const in Dawn, so it is not on window.
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(render, 30); });
      }
    } catch (_) {}
    // Same rule as Chesapeake chicks: a week must be picked before adding to cart.
    document.addEventListener('submit', function (e) {
      if (e.target !== form || !open.length) return;
      var v = currentVariant();
      if (chosen && v && v.iso === chosen && v.qty > 0) return;
      e.preventDefault(); e.stopImmediatePropagation();
      box.dataset.state = 'warn';
      msg.textContent = 'Please choose a ship week first.';
      try { select.focus(); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
    }, true);
    if (chosen) syncNative();
    render();
  }

  function boot() { document.querySelectorAll('[data-ch-partner-date]').forEach(mount); }
  window.ChPartnerDate = { mount: mount, weekIso: weekIso };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
